import {
  Flex,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";

export default function AlertComponent({ show, title, status, description }) {
  return (
    <>
      {show && (
        <Flex
          position="fixed"
          top="0"
          bottom="0"
          left="0"
          right="0"
          justifyContent="center"
          alignItems="center"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          zIndex="9999"
        >
          <Alert
            status={status}
            variant='subtle'
            flexDirection='column'
            alignItems='center'
            justifyContent='center'
            textAlign='center'
            height='200px'
          >
            <AlertIcon boxSize='40px' mr={0} />
            <AlertTitle mt={4} mb={1} fontSize='lg'>
              {title}
            </AlertTitle>
            <AlertDescription maxWidth='sm'>
              {description}
            </AlertDescription>
          </Alert>
        </Flex>
      )}
    </>
  );
}
